import EditInfo from './editInfo';
import ProfileInfo from './profileInfo';

const ProfileCenter = () => {
  return (
    <>
      <EditInfo />
      <ProfileInfo />
    </>
  );
};

export default ProfileCenter;
